import React from "react";

/* Auto-composed service animations -- pure CSS/SVG, no images */

const AnimQuickApproval = () => (
  <div className="sva sva-approval" aria-hidden="true">
    <div className="sva-approval-stage">
      <div className="sva-approval-glow" />
      <div className="sva-approval-phone">
        <div className="sva-approval-notch" />
        <div className="sva-approval-screen">
          <div className="sva-approval-appHead">
            <div className="sva-approval-avatar" />
            <div className="sva-approval-headLines">
              <span className="sva-approval-hl sva-approval-hl1" />
              <span className="sva-approval-hl sva-approval-hl2" />
            </div>
          </div>
          <div className="sva-approval-field sva-approval-field1">
            <span className="sva-approval-flabel" />
            <span className="sva-approval-fbar" />
          </div>
          <div className="sva-approval-field sva-approval-field2">
            <span className="sva-approval-flabel" />
            <span className="sva-approval-fbar" />
          </div>
          <div className="sva-approval-field sva-approval-field3">
            <span className="sva-approval-flabel" />
            <span className="sva-approval-fbar" />
          </div>
          <div className="sva-approval-scan" />
          <div className="sva-approval-particles">
            <span className="sva-approval-pt sva-approval-pt1" />
            <span className="sva-approval-pt sva-approval-pt2" />
            <span className="sva-approval-pt sva-approval-pt3" />
            <span className="sva-approval-pt sva-approval-pt4" />
            <span className="sva-approval-pt sva-approval-pt5" />
            <span className="sva-approval-pt sva-approval-pt6" />
          </div>
        </div>
      </div>
      <div className="sva-approval-ring">
        <svg className="sva-approval-ringSvg" viewBox="0 0 120 120">
          <circle className="sva-approval-ringTrack" cx="60" cy="60" r="52" />
          <circle className="sva-approval-ringProg" cx="60" cy="60" r="52" />
        </svg>
        <div className="sva-approval-ringCenter">
          <div className="sva-approval-timer">10s</div>
        </div>
        <div className="sva-approval-check">
          <div className="sva-approval-ripple" />
          <div className="sva-approval-ripple sva-approval-ripple2" />
          <div className="sva-approval-checkDisc">
            <svg className="sva-approval-checkSvg" viewBox="0 0 52 52">
              <path className="sva-approval-checkPath" d="M14 27 L23 36 L39 18" />
            </svg>
          </div>
        </div>
      </div>
      <div className="sva-approval-pill">
        <span className="sva-approval-pillDot" />
        <span className="sva-approval-pillText">Approved</span>
      </div>
    </div>
  </div>
);

const AnimQuickPaperwork = () => (
  <div className="sva sva-paper" aria-hidden="true">
    <div className="sva-paper-stage">
      <div className="sva-paper-glow" />
      <div className="sva-paper-badge">
        <span className="sva-paper-badge-num">3</span>
        <span className="sva-paper-badge-label">Docs</span>
      </div>
      <div className="sva-paper-deck">
        <div className="sva-paper-doc sva-paper-doc1">
          <div className="sva-paper-doc-inner">
            <div className="sva-paper-doc-head">
              <div className="sva-paper-photo" />
              <div className="sva-paper-headlines">
                <span className="sva-paper-line sva-paper-line-title" />
                <span className="sva-paper-line sva-paper-line-sub" />
              </div>
            </div>
            <div className="sva-paper-body">
              <span className="sva-paper-line" />
              <span className="sva-paper-line" />
              <span className="sva-paper-line sva-paper-line-short" />
            </div>
            <div className="sva-paper-tag">Aadhaar</div>
          </div>
          <div className="sva-paper-stamp">
            <svg viewBox="0 0 24 24" className="sva-paper-check">
              <circle cx="12" cy="12" r="11" className="sva-paper-check-bg" />
              <path d="M6.5 12.5l3.5 3.5 7.5-8" className="sva-paper-check-mark" />
            </svg>
          </div>
        </div>
        <div className="sva-paper-doc sva-paper-doc2">
          <div className="sva-paper-doc-inner">
            <div className="sva-paper-doc-head">
              <div className="sva-paper-photo" />
              <div className="sva-paper-headlines">
                <span className="sva-paper-line sva-paper-line-title" />
                <span className="sva-paper-line sva-paper-line-sub" />
              </div>
            </div>
            <div className="sva-paper-body">
              <span className="sva-paper-line" />
              <span className="sva-paper-line" />
              <span className="sva-paper-line sva-paper-line-short" />
            </div>
            <div className="sva-paper-tag">PAN</div>
          </div>
          <div className="sva-paper-stamp">
            <svg viewBox="0 0 24 24" className="sva-paper-check">
              <circle cx="12" cy="12" r="11" className="sva-paper-check-bg" />
              <path d="M6.5 12.5l3.5 3.5 7.5-8" className="sva-paper-check-mark" />
            </svg>
          </div>
        </div>
        <div className="sva-paper-doc sva-paper-doc3">
          <div className="sva-paper-doc-inner">
            <div className="sva-paper-doc-head">
              <div className="sva-paper-photo" />
              <div className="sva-paper-headlines">
                <span className="sva-paper-line sva-paper-line-title" />
                <span className="sva-paper-line sva-paper-line-sub" />
              </div>
            </div>
            <div className="sva-paper-body">
              <span className="sva-paper-line" />
              <span className="sva-paper-line" />
              <span className="sva-paper-line sva-paper-line-short" />
            </div>
            <div className="sva-paper-tag">Salary Slip</div>
          </div>
          <div className="sva-paper-stamp">
            <svg viewBox="0 0 24 24" className="sva-paper-check">
              <circle cx="12" cy="12" r="11" className="sva-paper-check-bg" />
              <path d="M6.5 12.5l3.5 3.5 7.5-8" className="sva-paper-check-mark" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const AnimDigitalApply = () => ( <div className="sva sva-digital" aria-hidden="true"> <div className="sva-digital-grid" /> <div className="sva-digital-dots" /> <div className="sva-digital-stage"> <div className="sva-digital-wave sva-digital-wave1" /> <div className="sva-digital-wave sva-digital-wave2" /> <div className="sva-digital-wave sva-digital-wave3" /> <div className="sva-digital-orbit"> <div className="sva-digital-icon sva-digital-icon-sms"> <svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4v-4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="#2f6fed"/><circle cx="8" cy="11" r="1.3" fill="#fff"/><circle cx="12" cy="11" r="1.3" fill="#fff"/><circle cx="16" cy="11" r="1.3" fill="#fff"/></svg> </div> <div className="sva-digital-icon sva-digital-icon-mail"> <svg viewBox="0 0 24 24" width="20" height="20"><rect x="2" y="5" width="20" height="14" rx="2" fill="#509540"/><path d="M3 7l9 6 9-6" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round"/></svg> </div> <div className="sva-digital-icon sva-digital-icon-clock"> <svg viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="10" fill="#f59e0b"/><path d="M12 7v5l3.5 2" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg> </div> <div className="sva-digital-icon sva-digital-icon-247"> <span className="sva-digital-247txt">24/7</span> </div> </div> <div className="sva-digital-phone"> <div className="sva-digital-phone-glow" /> <div className="sva-digital-screen"> <div className="sva-digital-statusbar"> <span className="sva-digital-notch" /> <span className="sva-digital-sig" /> </div> <div className="sva-digital-appbrand"> <svg viewBox="0 0 24 24" width="22" height="22"><circle cx="12" cy="12" r="11" fill="#509540"/><path d="M7 12.5l3 3 6.5-7" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg> <span className="sva-digital-appname">QuickLoan</span> </div> <div className="sva-digital-field sva-digital-field1"><span className="sva-digital-fillbar sva-digital-fill1" /></div> <div className="sva-digital-field sva-digital-field2"><span className="sva-digital-fillbar sva-digital-fill2" /></div> <div className="sva-digital-field sva-digital-field3"><span className="sva-digital-fillbar sva-digital-fill3" /></div> <div className="sva-digital-applybtn"> <span className="sva-digital-applylabel">Apply</span> <span className="sva-digital-applycheck"> <svg viewBox="0 0 24 24" width="16" height="16"><path d="M5 12.5l4 4 10-11" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/></svg> </span> </div> </div> <div className="sva-digital-tap"> <span className="sva-digital-ripple" /> <span className="sva-digital-ripple sva-digital-ripple2" /> <span className="sva-digital-finger" /> </div> </div> </div> </div> );

const AnimFlexible = () => (
  <div className="sva sva-flex" aria-hidden="true">
    <div className="sva-flex-glow" />
    <div className="sva-flex-card">
      <div className="sva-flex-header">
        <div className="sva-flex-title">
          <span className="sva-flex-rupee">₹</span>
          <span className="sva-flex-titletxt">Loan Your Way</span>
        </div>
        <div className="sva-flex-badge">
          <span className="sva-flex-dot" />
          Flexible
        </div>
      </div>

      <div className="sva-flex-row">
        <div className="sva-flex-rowlabel">
          <span>Amount</span>
          <span className="sva-flex-amount">
            <span className="sva-flex-amt sva-flex-amt1">₹5,000</span>
            <span className="sva-flex-amt sva-flex-amt2">₹42,000</span>
            <span className="sva-flex-amt sva-flex-amt3">₹1,00,000</span>
          </span>
        </div>
        <div className="sva-flex-track">
          <div className="sva-flex-fill sva-flex-fillA" />
          <div className="sva-flex-thumb sva-flex-thumbA">
            <div className="sva-flex-thumbinner" />
          </div>
        </div>
        <div className="sva-flex-scale">
          <span>₹5K</span>
          <span>₹50K</span>
          <span>₹1L</span>
        </div>
      </div>

      <div className="sva-flex-row">
        <div className="sva-flex-rowlabel">
          <span>Tenure</span>
          <span className="sva-flex-amount">
            <span className="sva-flex-amt sva-flex-day1">1 day</span>
            <span className="sva-flex-amt sva-flex-day2">28 days</span>
            <span className="sva-flex-amt sva-flex-day3">60 days</span>
          </span>
        </div>
        <div className="sva-flex-track">
          <div className="sva-flex-fill sva-flex-fillB" />
          <div className="sva-flex-thumb sva-flex-thumbB">
            <div className="sva-flex-thumbinner" />
          </div>
        </div>
        <div className="sva-flex-scale">
          <span>1d</span>
          <span>30d</span>
          <span>60d</span>
        </div>
      </div>

      <div className="sva-flex-bars">
        <div className="sva-flex-bar sva-flex-bar1" />
        <div className="sva-flex-bar sva-flex-bar2" />
        <div className="sva-flex-bar sva-flex-bar3" />
        <div className="sva-flex-bar sva-flex-bar4" />
        <div className="sva-flex-bar sva-flex-bar5" />
      </div>

      <div className="sva-flex-foot">
        <svg viewBox="0 0 24 24" className="sva-flex-check">
          <circle cx="12" cy="12" r="11" className="sva-flex-checkbg" />
          <path d="M7 12.5l3 3 7-7" className="sva-flex-checkmark" />
        </svg>
        <span>Choose your amount &amp; tenure</span>
      </div>
    </div>
  </div>
);

const AnimRepayment = () => (
  <div className="sva sva-repay" aria-hidden="true">
    <div className="sva-repay-stage">
      <div className="sva-repay-glow" />

      <div className="sva-repay-ringwrap">
        <svg className="sva-repay-ring" viewBox="0 0 120 120">
          <defs>
            <linearGradient id="repayGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#6dd05a" />
              <stop offset="100%" stopColor="#509540" />
            </linearGradient>
          </defs>
          <circle className="sva-repay-ring-track" cx="60" cy="60" r="50" />
          <circle className="sva-repay-ring-fill" cx="60" cy="60" r="50" />
        </svg>

        <div className="sva-repay-dial">
          <svg className="sva-repay-clock" viewBox="0 0 60 60">
            <circle className="sva-repay-clock-face" cx="30" cy="30" r="26" />
            <line className="sva-repay-hand-h" x1="30" y1="30" x2="30" y2="18" />
            <line className="sva-repay-hand-m" x1="30" y1="30" x2="30" y2="12" />
            <circle className="sva-repay-hand-dot" cx="30" cy="30" r="2.4" />
            <circle className="sva-repay-tick sva-repay-tick1" cx="30" cy="7" r="1.4" />
            <circle className="sva-repay-tick sva-repay-tick2" cx="53" cy="30" r="1.4" />
            <circle className="sva-repay-tick sva-repay-tick3" cx="30" cy="53" r="1.4" />
            <circle className="sva-repay-tick sva-repay-tick4" cx="7" cy="30" r="1.4" />
          </svg>
          <div className="sva-repay-pct">PAID</div>
        </div>

        <div className="sva-repay-bell">
          <svg viewBox="0 0 24 24" className="sva-repay-bell-svg">
            <path className="sva-repay-bell-body" d="M12 2.5a5.2 5.2 0 0 0-5.2 5.2c0 5-2.1 6.4-2.1 6.4h14.6s-2.1-1.4-2.1-6.4A5.2 5.2 0 0 0 12 2.5z" />
            <path className="sva-repay-bell-clap" d="M10.4 17.4a1.7 1.7 0 0 0 3.2 0z" />
          </svg>
          <span className="sva-repay-bell-ping sva-repay-bell-ping1" />
          <span className="sva-repay-bell-ping sva-repay-bell-ping2" />
        </div>
      </div>

      <div className="sva-repay-chips">
        <div className="sva-repay-chip sva-repay-chip1">
          <span className="sva-repay-chip-ic">
            <svg viewBox="0 0 24 24"><path d="M4 7h16v10H4z" /><path d="M9 12h6" /></svg>
          </span>
          <span className="sva-repay-chip-tx">UPI</span>
          <span className="sva-repay-chip-tick">
            <svg viewBox="0 0 24 24"><path d="M5 13l4 4 10-11" /></svg>
          </span>
        </div>
        <div className="sva-repay-chip sva-repay-chip2">
          <span className="sva-repay-chip-ic">
            <svg viewBox="0 0 24 24"><path d="M4 9l8-4 8 4" /><path d="M5 9v8M19 9v8M9 9v8M15 9v8M3 19h18" /></svg>
          </span>
          <span className="sva-repay-chip-tx">Net Banking</span>
          <span className="sva-repay-chip-tick">
            <svg viewBox="0 0 24 24"><path d="M5 13l4 4 10-11" /></svg>
          </span>
        </div>
        <div className="sva-repay-chip sva-repay-chip3">
          <span className="sva-repay-chip-ic">
            <svg viewBox="0 0 24 24"><path d="M12 4a8 8 0 1 1-7 4" /><path d="M5 4v5h5" /></svg>
          </span>
          <span className="sva-repay-chip-tx">Auto-Debit</span>
          <span className="sva-repay-chip-tick">
            <svg viewBox="0 0 24 24"><path d="M5 13l4 4 10-11" /></svg>
          </span>
        </div>
      </div>

      <div className="sva-repay-caption">
        <span className="sva-repay-cap-dot" />
        <span className="sva-repay-cap-tx">Repay in 7&ndash;60 days</span>
      </div>
    </div>
  </div>
);

const AnimCollateralFree = () => (
  <div className="sva sva-nocol" aria-hidden="true">
    <div className="sva-nocol-bg" />
    <div className="sva-nocol-grid" />
    <div className="sva-nocol-glow" />

    <div className="sva-nocol-stage">
      <div className="sva-nocol-shield">
        <svg viewBox="0 0 120 140" className="sva-nocol-shieldSvg">
          <defs>
            <linearGradient id="nocolShieldFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#6dd05a" />
              <stop offset="55%" stopColor="#509540" />
              <stop offset="100%" stopColor="#3c7a30" />
            </linearGradient>
            <linearGradient id="nocolShieldEdge" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
              <stop offset="40%" stopColor="#ffffff" stopOpacity="0.15" />
              <stop offset="100%" stopColor="#1C2634" stopOpacity="0.1" />
            </linearGradient>
          </defs>
          <path
            className="sva-nocol-shieldBody"
            d="M60 6 L108 24 L108 70 C108 104 86 124 60 134 C34 124 12 104 12 70 L12 24 Z"
            fill="url(#nocolShieldFill)"
          />
          <path
            className="sva-nocol-shieldShine"
            d="M60 6 L108 24 L108 70 C108 104 86 124 60 134 C34 124 12 104 12 70 L12 24 Z"
            fill="url(#nocolShieldEdge)"
          />
          <path
            className="sva-nocol-check"
            d="M40 70 L55 86 L84 50"
            fill="none"
            stroke="#ffffff"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="sva-nocol-ring" />
        <div className="sva-nocol-ring sva-nocol-ring2" />
      </div>

      <div className="sva-nocol-assets">
        <div className="sva-nocol-asset sva-nocol-assetA">
          <svg viewBox="0 0 48 48" className="sva-nocol-assetSvg">
            <path d="M6 22 L24 8 L42 22 L42 42 L6 42 Z" fill="none" stroke="#1C2634" strokeOpacity="0.55" strokeWidth="3" strokeLinejoin="round" />
            <rect x="19" y="30" width="10" height="12" fill="#1C2634" fillOpacity="0.4" />
          </svg>
          <div className="sva-nocol-slash" />
        </div>
        <div className="sva-nocol-asset sva-nocol-assetB">
          <svg viewBox="0 0 48 48" className="sva-nocol-assetSvg">
            <path d="M8 30 L13 18 L35 18 L40 30 L40 38 L8 38 Z" fill="none" stroke="#1C2634" strokeOpacity="0.55" strokeWidth="3" strokeLinejoin="round" />
            <circle cx="16" cy="38" r="4" fill="#1C2634" fillOpacity="0.4" />
            <circle cx="32" cy="38" r="4" fill="#1C2634" fillOpacity="0.4" />
          </svg>
          <div className="sva-nocol-slash" />
        </div>
      </div>

      <div className="sva-nocol-slip">
        <div className="sva-nocol-slipPaper">
          <div className="sva-nocol-slipHead">
            <span className="sva-nocol-rupee">₹</span>
            <span className="sva-nocol-slipTitle">SALARY</span>
          </div>
          <div className="sva-nocol-line sva-nocol-line1" />
          <div className="sva-nocol-line sva-nocol-line2" />
          <div className="sva-nocol-line sva-nocol-line3" />
          <div className="sva-nocol-amount" />
        </div>
        <div className="sva-nocol-stamp">
          <svg viewBox="0 0 24 24" className="sva-nocol-stampTick">
            <path d="M5 12 L10 17 L19 7" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="sva-nocol-stampTxt">APPROVED</span>
        </div>
        <div className="sva-nocol-shimmer" />
      </div>

      <span className="sva-nocol-spark sva-nocol-spark1" />
      <span className="sva-nocol-spark sva-nocol-spark2" />
      <span className="sva-nocol-spark sva-nocol-spark3" />
    </div>

    <div className="sva-nocol-caption">
      <span className="sva-nocol-capDot" />
      100% Unsecured · No Asset Pledge
    </div>
  </div>
);

export {
  AnimQuickApproval,
  AnimQuickPaperwork,
  AnimDigitalApply,
  AnimFlexible,
  AnimRepayment,
  AnimCollateralFree,
};
